import type { CybusNode, SortableColumn } from '../../../domain'

import { ResourcePageSubscriptionUsecase } from '../Resources'

export class ManageNodesUsecase extends ResourcePageSubscriptionUsecase<'nodes'> {
    protected readonly pageName = 'nodes'

    protected readonly pageAddress = 'nodesPage'

    protected initialSortColumn: SortableColumn<CybusNode> = 'service'
}
